<script>
  import getTranslation from '../../../utilities/getTranslation';

  export let isMostPopular, subscription;
</script>

<style lang="scss">
  @use './styles/sharedStyles' as *;
  @use '../index' as *;

  .card {
    @include generalCardStyle;
  }

  .product-description {
    margin: 0;

    p {
      margin-block-end: 0;

      @include mq($until: desktop) {
        z-index: 1;
      }
    }

    @include mq($until: desktop) {
      margin-block-start: -0.4rem;
    }
  }
</style>

<div class="card product-description" class:most-popular-border={isMostPopular}>
  <p>
    {@html getTranslation(subscription.informationKeys, 'description.body.v2', '')}
  </p>
</div>
